import { createAction, ActionType } from 'typesafe-actions'

export const requestEngagementReportFailAction = createAction(
  'REQUEST_ENGAGEMENT_REPORT_FAIL'
)<Error>()

export type EngagementReportActions = ActionType<
  typeof requestEngagementReportFailAction
>
